module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciLz4="


//////////////////
// WEBPACK FOOTER
// ./fonts/icons.svg
// module id = 54
// module chunks = 0